import React, { useState }from 'react';

import { useGetProductsQuery } from '../../app/config/redux/slices/api/productApiSlice';
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart } from "../../app/config/redux/slices/cartSlice";
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { IMAGE_URL } from '../../constants';

const NewArrivalTwo = () => {

    const [limit] = useState(10);
    const [page] = useState(1);
    const [quantity] = useState(1);

    const { data, isLoading, isFetching, error } = useGetProductsQuery({limit});

    const products = data?.products?.data || [];
    const size = data?.products?.total || 0;

    const dispatch = useDispatch();

    const cartItems = useSelector((state) => state.cart.cartItems);
    const cartItemsMap = cartItems.reduce((acc, item) => {
        acc[item.product.id] = item.quantity;
        return acc;
    }, {});

    //Slider
    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1599,
                settings: {
                    slidesToShow: 6,

                },
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 4,

                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,

                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,

                },
            },
            {
                breakpoint: 424,
                settings: {
                    slidesToShow: 1,

                },
            },

        ],
    };
    return (
        <section className="new-arrival pb-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">You Might Also Like</h5>
                        <div className="flex-align mr-point gap-16">
                            <Link
                                to="/shop"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                All Products
                            </Link>

                        </div>
                    </div>
                </div>
                <div className="new-arrival__slider arrow-style-two">
                    <Slider {...settings}>
                        {products.map((product) => {

                            const isInCart = cartItems.some(item => item.product.id === product.id);

                            return (
                            <div key={product.id}>
                                <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                                    <Link
                                        to={`/product-details/${product.id}`}
                                        className="product-card__thumb flex-center"
                                    >
                                        <img
                                            src={
                                                product.image_url
                                                    ? product.image_url
                                                    : product.image
                                                        ? `${IMAGE_URL}/${product.image}`
                                                        : "/assets/images/thumbs/product-two-img1.png"
                                            }
                                            srcSet={product.image_srcset || undefined}
                                            sizes="(max-width: 576px) 400px,
                                                (max-width: 992px) 800px,
                                                1200px"
                                            alt={product.name}
                                            loading="lazy"
                                        />
                                    </Link>
                                    <div className="product-card__content p-sm-2">
                                        <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                            <Link to={`/product-details/${product.id}`} className="link text-line-2">
                                                {product.name}
                                            </Link>
                                        </h6>
                                        <div className="flex-align gap-4">
                                            <span className="text-main-600 text-md d-flex">
                                                <i className="ph-fill ph-storefront" />
                                            </span>
                                            <span className="text-gray-500 text-xs">
                                                By {product.vendor_name}
                                            </span>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="product-card__price mb-8">
                                                <span className="text-heading text-md fw-semibold ">
                                                    ₹{product.price - (product.price / 100) * product.discount}  <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                                                </span>
                                                {product.discount > 0 && (
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                                                    ₹{product.price}
                                                </span>
                                                )}
                                            </div>
                                            {/* <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-600">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-600">(17k)</span>
                                            </div> */}
                                            <button
                                                onClick={() => !isInCart && dispatch(addToCart({ product }))}
                                                className={`product-card__cart btn ${
                                                    isInCart
                                                        ? "bg-main-50 text-main-600 hover-bg-main-600 hover-text-white disabled"
                                                        : "bg-main-50 text-main-600 hover-bg-main-600 hover-text-white"
                                                } py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center`}
                                                disabled={isInCart}
                                            >
                                                {isInCart ? "Added To Cart" : "Add To Cart"} <i className="ph ph-shopping-cart" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )})}

                    </Slider>
                </div>
            </div>
        </section>

    )
}

export default NewArrivalTwo